import TableComponent, {
  IColumnProps,
} from '../../../components/TableComponent';
import { useGetAllLicensesAsync } from '../../../services/LicenseService/hooks/useMutations';
import React, { useEffect, useState } from 'react';
import { ILicenseSimpleProps } from '../../../services/LicenseService/types';
import ButtonComponent from '../../../components/ButtonComponent';
import { Add } from '@mui/icons-material';
import ButtonActionsComponent from '../../../components/ButtonActionsComponent';
import { Box } from '@mui/material';

import ConfirmDeleteModalComponent from '../../../components/ConfirmDeleteModalComponent';
import { IPaginationParams } from '../../../services/types';
import { ILprDeviceFilterProps } from '../../../services/Devices/LprService/types';
import SchoolTicketEditionModal from './SchoolTicketEditionModal';
import {
  useDeleteSchoolTicketAsync,
  useGetAllSchoolTicketByLicenseAsync,
  useGetSchoolTicketByIdAsync,
} from '../../../services/SchoolTicket/hooks/useMutation';
import {
  ISchoolTicketSimpleProps,
  ISchoolTicketBaseProps,
  ISchoolTicketProps,
} from '../../../services/SchoolTicket/types';
import SchoolShiftEditionModal from '../../SchoolShiftPage/_components/SchoolShiftEditionModal';
import ImageSimpleColumnComponent from '../../../components/ImageSimpleColumnComponent';

const LicensesList = () => {
  const [schoolTransportation, setSchoolTransportation] = useState<
    ISchoolTicketSimpleProps[]
  >([]);
  const [isVisibleImageModal, setIsVisibleImageModal] =
    useState<boolean>(false);
  const [imageUrlToRender, setImageUrlToRender] = useState<string>('');
  const [isVisibleEditionModal, setIsVisibleEditionModal] =
    useState<boolean>(false);
  const [selectedItemToDelete, setSelectedItemToDelete] =
    useState<ISchoolTicketSimpleProps>();
  const [responsibleToEdit, setResponsibleToEdit] = useState<
    ISchoolTicketProps | undefined
  >(undefined);
  const [isVisibleDeleteItemModal, setIsVisibleDeleteItemModal] =
    useState<boolean>(false);
  const [pagination, setPagination] = useState<IPaginationParams>({
    pageNumber: 1,
    pageSize: 10,
  });
  const [filter, setFilter] = useState<ILprDeviceFilterProps>({
    name: '',
  });
  const { mutateAsync, reset } = useGetAllSchoolTicketByLicenseAsync();
  const { mutateAsync: mutateResponsibleAsync } = useGetSchoolTicketByIdAsync();
  const {
    mutateAsync: mutateDeleteResponsibleAsync,
    isLoading: isLoadingDeleteResponsible,
  } = useDeleteSchoolTicketAsync();
  const handleOpenImageModal = (imageUrl: string) => {
    setIsVisibleImageModal(true);
    setImageUrlToRender(imageUrl);
  };

  const columns: IColumnProps[] = [
    {
      id: 'responsible',
      label: 'Responsável de origem',
      width: '15%',
      render: (resp: any) => resp?.name || 'Não informado',
    },
    {
      id: 'name',
      label: 'Responsável autorizado',
      width: '15%',
    },
    {
      id: 'student',
      label: 'Aluno',
      width: '15%',
      render: (student: any) => student?.name || '',
    },
    {
      id: 'cpf',
      label: 'CPF',
      width: '15%',
    },
    {
      id: 'description',
      label: 'Descrição',
      width: '20%',
    },
    {
      id: 'image',
      label: 'Imagem',
      width: '15%',
      align: 'center',
      render: (url) => {
        return (
          <ImageSimpleColumnComponent
            url={url}
            onClick={() => handleOpenImageModal(url)}
          />
        );
      },
    },
    {
      id: 'id',
      label: 'Ações',
      align: 'center',
      width: 'min',
      render: (id) => (
        <ButtonActionsComponent
          key={id}
          isWithDefaultOptionsList
          handleDelete={() => handleDeleteItem(Number(id))}
          handleEdit={() => handleEdit(Number(id))}
        />
      ),
    },
  ];

  useEffect(() => {
    mutateAsync().then(setSchoolTransportation);
  }, []);
  const handleDeleteItem = async (id: number) => {
    const responsible: any = await mutateResponsibleAsync(id);
    setSelectedItemToDelete(responsible);
    setIsVisibleDeleteItemModal(true);
  };

  const handleEdit = (id: number) => {
    mutateResponsibleAsync(id).then(setResponsibleToEdit);
    setIsVisibleEditionModal(true);
  };
  const refetchResponsible = () => {
    mutateAsync().then(setSchoolTransportation);
  };
  const handleConfirmDeletion = () => {
    if (selectedItemToDelete?.id)
      mutateDeleteResponsibleAsync(selectedItemToDelete?.id).then(() => {
        setPagination((oldStt) => ({ ...oldStt, pageNumber: 1 }));
        setIsVisibleDeleteItemModal(false);
        refetchResponsible();
      });
  };
  const handleCancelDeletion = () => {
    setIsVisibleDeleteItemModal(false);
    setSelectedItemToDelete(undefined);
  };
  return (
    <>
      <TableComponent
        title="Autorizados Escola"
        rows={schoolTransportation}
        columns={columns}
      />
      <ConfirmDeleteModalComponent
        isLoading={isLoadingDeleteResponsible}
        isVisibleDeleteDialog={isVisibleDeleteItemModal}
        setIsVisibleDeleteDialog={setIsVisibleDeleteItemModal}
        title={'Excluir Autorização'}
        message={`Tem certeza que deseja excluir esta autorização "${selectedItemToDelete?.id}"?`}
        handleCancelDeletion={handleCancelDeletion}
        handleConfirmDeletion={handleConfirmDeletion}
      />
      <SchoolTicketEditionModal
        handleSaveForm={() => mutateAsync().then(setSchoolTransportation)}
        responsibleEdit={responsibleToEdit}
        isOpen={isVisibleEditionModal}
        setIsOpen={setIsVisibleEditionModal}
      />
    </>
  );
};

export default LicensesList;
